export class Shape2D {
}
//# sourceMappingURL=Shape2D.js.map